/**
 * Claims the dashboard reads from its own session JWT. The token is not verified here — the backend
 * does that on every request — so nothing read from it may grant anything; it only drives display.
 */
export interface SessionClaims {
  /** `_id` of the staff member who opened this session on the customer's behalf. */
  impersonatedBy?: string;
}

export const readSessionClaims = (token: string | null | undefined): SessionClaims => {
  if (!token) return {};
  try {
    const segment = token.split('.')[1] ?? '';
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const payload = JSON.parse(atob(padded)) as { impersonated_by?: unknown };
    return typeof payload.impersonated_by === 'string' ? { impersonatedBy: payload.impersonated_by } : {};
  } catch {
    return {};
  }
};
